import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Bushireforweddinginpune() {



    const cardData =
    {
        keyword: 'Bus Hire for Wedding in Pune',
        heading: 'Urbania on rent in pune: Bus Hire for Wedding in Pune',
        headingDescription: 'Urbania On Rent in Pune offers premium and reliable Bus Hire for Wedding in Pune services for families, wedding planners, and event organizers looking for comfortable and spacious group transportation. Our well‑maintained Force Urbania bus fleet provides ample seating, air‑conditioned comfort, and smooth performance, making it ideal for transporting wedding guests, family members, and bridal parties across Pune and nearby locations. With professional chauffeurs, flexible one‑way and round‑trip rental options, and convenient doorstep pickup from major areas including Hinjewadi, Baner, Wakad, Kharadi, Hadapsar, Kothrud, Pimpri Chinchwad, and Pune Airport, we ensure a punctual, safe, and stress‑free travel experience. Backed by 24/7 booking support, transparent pricing, and trusted service, Urbania On Rent in Pune stands out as the trusted choice for wedding bus hire in Pune.',

        top: 'Top Places to Visit in Pune with Pune on rent in pune',


"topPlaces": [
  {
    "title": "Shaniwar Wada",
    "description": "Shaniwar Wada, built in 1732 by the Peshwas, is Pune’s iconic fort and a symbol of Maratha glory. Known for its massive stone walls, grand gateways like Delhi Darwaza, and lush lawns, it served as the seat of Bajirao I’s administration. Despite being partially destroyed by fire, the remnants echo royal grandeur. Evening light-and-sound shows vividly bring Maratha history to life, making it a must-visit heritage site."
  },
  {
    "title": "Aga Khan Palace",
    "description": "Constructed in 1892, Aga Khan Palace is a historical monument linked to India’s freedom struggle. Mahatma Gandhi, Kasturba Gandhi, and Mahadev Desai were imprisoned here during the Quit India Movement. The palace now serves as a museum with Gandhi’s personal artifacts, photographs, and the samadhis of Kasturba and Mahadev Desai. Its sprawling gardens, Italian arches, and tranquil ambiance make it a symbol of sacrifice and patriotism."
  },
  {
    "title": "Dagdusheth Halwai Ganpati Temple",
    "description": "The Shreemant Dagdusheth Halwai Ganpati Temple is Pune’s most revered shrine, dedicated to Lord Ganesha. The idol, adorned with gold and jewels, attracts thousands of devotees daily. During Ganesh Chaturthi, the temple becomes the epicenter of grand celebrations. The temple trust is known for charitable work. Devotees find immense peace and blessings here, making it the spiritual heartbeat of Pune."
  },
  {
    "title": "Sinhagad Fort",
    "description": "Perched atop a rugged hill, Sinhagad Fort is famous for the 1670 battle where Tanaji Malusare sacrificed his life for Chhatrapati Shivaji Maharaj. Visitors can trek or drive to explore ancient ramparts, memorials, and scenic viewpoints. Local vendors offer traditional pithla-bhakri meals near the summit. The fort provides panoramic views of the Sahyadri ranges, blending history, adventure, and natural beauty."
  },
  {
    "title": "Pataleshwar Cave Temple",
    "description": "Pataleshwar Cave Temple is an 8th-century rock-cut shrine dedicated to Lord Shiva. Carved from a single basalt rock, it features monolithic pillars, a circular Nandi pavilion, and a peaceful sanctum. Despite being in a busy area, it maintains a tranquil spiritual ambiance. Its ancient carvings showcase early Indian craftsmanship, making it Pune’s hidden heritage retreat."
  },
  {
    "title": "Raja Dinkar Kelkar Museum",
    "description": "Raja Dinkar Kelkar Museum houses over 20,000 artifacts collected by Dr. Dinkar Kelkar, representing India’s rich cultural past. From traditional ornaments and musical instruments to household antiques and sculptures, it is a treasure trove of heritage. The recreated Mastani Mahal is a highlight, making it Pune’s living archive of art, craftsmanship, and history."
  },
  {
    "title": "Parvati Hill and Temple",
    "description": "Parvati Hill, one of Pune’s oldest landmarks, offers panoramic city views after climbing 103 stone steps. The hilltop Parvati Temple, dedicated to Lord Shiva and Goddess Parvati, was built during the Peshwa era. Smaller shrines and a museum add cultural charm. Sunrise and sunset visits are especially mesmerizing, making Parvati Hill a spiritual and scenic highlight."
  },
  {
    "title": "Osho Ashram",
    "description": "Located in Koregaon Park, the Osho International Meditation Resort is a global center for peace and self-discovery. Spread across landscaped gardens, it offers meditation sessions, wellness therapies, and mindfulness programs. Visitors from around the world come seeking relaxation and spiritual transformation, making it Pune’s international retreat for tranquility."
  },
  {
    "title": "Pu La Deshpande Garden",
    "description": "Pu La Deshpande Garden, inspired by Japan’s Korakuen Garden, is Pune’s largest landscaped park. Featuring flowing streams, arched bridges, and manicured lawns surrounded by seasonal flowers, it is ideal for families, photography enthusiasts, and peaceful strolls. The garden blends Japanese aesthetics with Indian nature, serving as Pune’s serene green sanctuary."
  },
  {
    "title": "Khadakwasla Dam",
    "description": "Khadakwasla Dam, built on the Mutha River, is a popular leisure spot for locals. The vast waterscape and surrounding hills create picturesque views, especially during monsoon. Street vendors sell roasted corn and tea, adding local flavor. The dam also serves as the gateway to Sinhagad Fort. Khadakwasla is Pune’s breezy weekend escape and sunset viewpoint."
  }
],




"services": [
{
"name": "Bus Hire for Wedding in Pune",
"description": "Bus Hire for Wedding in Pune offers comfortable and reliable buses for wedding events, ensuring timely pickups and safe transportation for guests across multiple venues."
},
{
"name": "Wedding Bus Hire Pune",
"description": "Wedding Bus Hire Pune provides well-maintained buses for weddings, with professional drivers, spacious seating, and clean interiors to make the journey smooth and enjoyable."
},
{
"name": "AC Wedding Bus Pune",
"description": "AC Wedding Bus Pune offers fully air-conditioned buses for a comfortable and pleasant travel experience during wedding functions and ceremonies."
},
{
"name": "Luxury Wedding Bus Pune",
"description": "Luxury Wedding Bus Pune delivers premium buses with plush seating and elegant interiors, perfect for transporting VIP guests in style and comfort."
},
{
"name": "Wedding Guest Transport Pune",
"description": "Wedding Guest Transport Pune ensures convenient and coordinated travel for all wedding guests, making group transportation stress-free and efficient."
},
{
"name": "Corporate Wedding Transport Pune",
"description": "Corporate Wedding Transport Pune offers organized bus services for corporate guests attending wedding functions, combining professionalism with comfort."
},
{
"name": "Affordable Wedding Bus Hire Pune",
"description": "Affordable Wedding Bus Hire Pune provides budget-friendly bus rental services for weddings without compromising on safety, comfort, or reliability."
},
{
"name": "Chauffeur Driven Wedding Bus Pune",
"description": "Chauffeur Driven Wedding Bus Pune ensures a stress-free wedding journey with verified and experienced drivers familiar with local routes."
},
{
"name": "Bus for Marriage Functions Pune",
"description": "Bus for Marriage Functions Pune provides safe and comfortable transportation for all types of marriage ceremonies and related events."
},
{
"name": "Bus for Wedding Events Pune",
"description": "Bus for Wedding Events Pune offers reliable and timely bus services specifically for weddings, ensuring smooth transportation for all guests."
},
{
"name": "Best Wedding Bus Rental Pune",
"description": "Best Wedding Bus Rental Pune is known for top-rated buses, professional service, and excellent customer satisfaction, making it a preferred choice for wedding transport."
},
{
"name": "Group Wedding Travel Pune",
"description": "Group Wedding Travel Pune offers spacious buses for large groups attending weddings, ensuring everyone travels together safely and comfortably."
},
{
"name": "Reliable Wedding Bus Service Pune",
"description": "Reliable Wedding Bus Service Pune delivers dependable bus rentals with a focus on punctuality, safety, and smooth travel experiences for wedding guests."
},
{
"name": "Wedding Transportation Pune",
"description": "Wedding Transportation Pune provides comprehensive transport solutions for weddings, including AC and non-AC buses, professional drivers, and well-coordinated travel schedules."
},
{
"name": "Premium Wedding Bus Hire Pune",
"description": "Premium Wedding Bus Hire Pune offers luxurious buses with modern interiors and superior comfort for VIP and premium wedding guests."
}
],
"tableData": [
["Bus Hire for Wedding in Pune", "Wedding Bus Hire Pune"],
["AC Wedding Bus Pune", "Luxury Wedding Bus Pune"],
["Wedding Guest Transport Pune", "Corporate Wedding Transport Pune"],
["Affordable Wedding Bus Hire Pune", "Chauffeur Driven Wedding Bus Pune"],
["Bus for Marriage Functions Pune", "Bus for Wedding Events Pune"],
["Best Wedding Bus Rental Pune", "Group Wedding Travel Pune"],
["Reliable Wedding Bus Service Pune", "Wedding Transportation Pune"],
["Premium Wedding Bus Hire Pune", ""]
],



whychoose : [
    {
        "WhyChooseheading": "Bus Hire for Wedding in Pune for Comfortable Group Travel",
        "WhyChoosedescription": "Bus Hire for Wedding in Pune is perfect for transporting guests, family members, and friends to wedding venues comfortably, ensuring a smooth and hassle-free journey."
    },
    {
        "WhyChooseheading": "Spacious and Modern Buses",
        "WhyChoosedescription": "Our wedding hire buses are equipped with air-conditioning, reclining seats, ample legroom, and sufficient luggage space for all guests and wedding essentials."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers",
        "WhyChoosedescription": "All drivers are trained, licensed, and experienced in Pune city and nearby routes, ensuring safe, timely, and stress-free travel for wedding events."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing",
        "WhyChoosedescription": "Bus Hire for Wedding in Pune offers competitive pricing with no hidden charges, making group travel for weddings economical and reliable."
    },
    {
        "WhyChooseheading": "24/7 Booking and Customer Support",
        "WhyChoosedescription": "We provide round-the-clock booking assistance and dedicated support for inquiries, reservations, and last-minute travel arrangements for weddings."
    },
    {
        "WhyChooseheading": "Flexible Packages for Wedding Events",
        "WhyChoosedescription": "Available for wedding day transportation, pre-wedding events, multiple pickup/drop points, and customized schedules as per your wedding plan."
    },
    {
        "WhyChooseheading": "Clean and Well-Maintained Vehicles",
        "WhyChoosedescription": "All buses are thoroughly cleaned, sanitized, and maintained to ensure guest comfort and safety during the wedding journey."
    },
    {
        "WhyChooseheading": "Punctual and Reliable Service",
        "WhyChoosedescription": "Our Bus Hire for Wedding in Pune guarantees on-time pickups, reliable service, and a smooth travel experience for all wedding guests."
    }
]
}
const faqData = [
    {
        question: 'Can Bus Hire for Wedding in Pune accommodate large groups?',
        answer: 'Yes, it is ideal for transporting large groups of wedding guests, family members, and friends comfortably.'
    },
    {
        question: 'How can I book Bus Hire for Wedding in Pune?',
        answer: 'Bookings can be made via phone, WhatsApp, or online for convenient and quick reservations.'
    },
    {
        question: 'Why choose Bus Hire for Wedding in Pune?',
        answer: 'This service offers spacious seating, professional drivers, clean vehicles, flexible packages, and transparent pricing.'
    },
    {
        question: 'Are drivers experienced with wedding event travel?',
        answer: 'Yes, all drivers are trained and familiar with Pune city routes and nearby wedding venues.'
    },
    {
        question: 'Can pickup and drop locations be customized?',
        answer: 'Absolutely. Flexible pickup and drop-off points are available across Pune and surrounding areas.'
    },
    {
        question: 'Is Bus Hire for Wedding in Pune available 24/7?',
        answer: 'Yes, booking services and customer support are available 24/7.'
    },
    {
        question: 'Are hygiene and safety standards maintained?',
        answer: 'Yes, all buses are thoroughly cleaned, sanitized, and well-maintained for passenger safety.'
    },
    {
        question: 'What payment options are accepted?',
        answer: 'Payments can be made via UPI, digital wallets, credit/debit cards, bank transfers, and corporate billing.'
    },
    {
        question: 'Is customer support available during the journey?',
        answer: 'Yes, dedicated customer support is available throughout the wedding travel.'
    },
    {
        question: 'Is this service suitable for families and large wedding groups?',
        answer: 'Yes, Bus Hire for Wedding in Pune is ideal for families, friends, and large groups attending wedding events.'
    }
];

const testimonials = [
    {
        id: 1,
        name: 'Mr. Prakash Deshmukh',
        feedback: 'We hired a bus for our wedding guests in Pune. The bus was spacious, clean, and the service was punctual and reliable.',
        rating: 5
    },
    {
        id: 2,
        name: 'Ms. Sheetal Kulkarni',
        feedback: 'Professional service and experienced driver. Bus Hire for Wedding in Pune made transporting our wedding guests smooth and stress-free.',
        rating: 5
    }
];














































































































    const Images = [
        { place: "/images/keyword/1.jpg", text: "Urbania On Rent Pune", link: "urbania-on-rent-pune" },
        { place: "/images/keyword/2.jpg", text: "Urbania on Rent in Pimpri Chinchwad", link: "urbania-on-rent-in-pimpri-chinchwad" },
        { place: "/images/keyword/3.jpg", text: "Urbania Hire for Corporate Events in Pune", link: "urbania-hire-for-corporate-events-in-pune" },
        { place: "/images/keyword/4.jpg", text: "17 Seater Urbania on Rent in Pune", link: "17-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/5.jpg", text: "14 Seater Urbania on Rent in Pune", link: "14-seater-urbania-on-rent-in-pune" },
        { place: "/images/keyword/6.jpg", text: "Urbania on Rent in Kharadi", link: "urbania-on-rent-in-kharadi" },
        { place: "/images/keyword/7.jpg", text: "Urbania on Rent in Hadapsar", link: "urbania-on-rent-in-hadapsar" },
        { place: "/images/keyword/8.jpg", text: "Urbania on Rent in Kothrud", link: "urbania-on-rent-in-kothrud" },
        { place: "/images/keyword/9.jpg", text: "Urbania On Rent in Bibwewadi", link: "urbania-on-rent-in-bibwewadi" },
        { place: "/images/keyword/10.jpg", text: "Urbania on Rent in Koregaon Park", link: "urbania-on-rent-in-koregaon-park" },
        { place: "/images/keyword/11.jpg", text: "Urbania On Rent in Kalyani Nagar", link: "urbania-on-rent-in-kalyani-nagar" },
        { place: "/images/keyword/12.jpg", text: "Urbania On Rent in Mundhwa Pune", link: "urbania-on-rent-in-mundhwa-pune" },
        { place: "/images/keyword/13.jpg", text: "Urbania Bus On Rent in Baner", link: "urbania-bus-on-rent-in-baner" },
        { place: "/images/keyword/14.jpg", text: "Urbania AC Bus On Rent in Aundh", link: "urbania-ac-bus-on-rent-in-aundh" },
        { place: "/images/keyword/15.jpg", text: "Urbania Bus On Rent in Hinjewadi", link: "urbania-bus-on-rent-in-hinjewadi" },
        { place: "/images/keyword/16.jpg", text: "Urbania on Rent in Bhosari", link: "urbania-on-rent-in-bhosari" },
        { place: "/images/keyword/17.jpg", text: "Urbania on Rent in Pune Station", link: "urbania-on-rent-in-pune-station" },
        { place: "/images/keyword/18.jpg", text: "Urbania On Rent in Chakan", link: "urbania-on-rent-in-chakan" },
        { place: "/images/keyword/19.jpg", text: "Urbania On Rent in Moshi", link: "urbania-on-rent-in-moshi" },
        { place: "/images/keyword/20.jpg", text: "Urbania On Rent in Charholi Budruk", link: "urbania-on-rent-in-charholi-budruk" },
        { place: "/images/keyword/21.jpg", text: "Urbania On Rent in Nigdi Pradhikaran", link: "urbania-on-rent-in-nigdi-pradhikaran" },
        { place: "/images/keyword/22.jpg", text: "Urbania On Rent in Lohegaon", link: "urbania-on-rent-in-lohegaon" },
        { place: "/images/keyword/23.jpg", text: "Urbania On Rent in Wagholi", link: "urbania-on-rent-in-wagholi" },
        { place: "/images/keyword/24.jpg", text: "Urbania Rental Service in Pune", link: "urbania-rental-service-in-pune" },
        { place: "/images/keyword/25.jpg", text: "Best Urbania on Rent in Pune", link: "best-urbania-on-rent-in-pune" }
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Bus Hire for Wedding in Pune",
  "image": "https://urbaniaonrentpune.in/assets/images/wedding-bus-pune.jpg",
  "description": "Bus Hire for Wedding in Pune offers AC and luxury buses for wedding guest transport, corporate wedding trips, and group travel. Chauffeur-driven buses ensure safe, comfortable, and convenient transportation for marriage functions and wedding events in Pune.",
  "brand": {
    "@type": "Brand",
    "name": "Urbania on Rent in Pune"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "950",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "15000",
    "availability": "https://schema.org/InStock",
    "url": "https://urbaniaonrentpune.in/bus-hire-for-wedding-pune"
  }
};






    return (
        <div>
<Helmet>
  <title>
    Call:+91 9209423113 | Bus Hire for Wedding in Pune | AC & Luxury Wedding Buses 
  </title>

  <meta
    name="description"
    content="Book Bus Hire for Wedding in Pune for guest transport, corporate wedding trips, and group travel. AC and luxury chauffeur-driven buses provide safe, comfortable, and convenient transportation for marriage functions and wedding events."
  />

  <meta
    name="keywords"
    content="Bus Hire for Wedding in Pune, Wedding Bus Hire Pune, AC Wedding Bus Pune, Luxury Wedding Bus Pune, Wedding Guest Transport Pune, Corporate Wedding Transport Pune, Affordable Wedding Bus Hire Pune, Chauffeur Driven Wedding Bus Pune, Bus for Marriage Functions Pune, Bus for Wedding Events Pune, Best Wedding Bus Rental Pune, Group Wedding Travel Pune, Reliable Wedding Bus Service Pune, Wedding Transportation Pune, Premium Wedding Bus Hire Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

            <div
                className="breadcumb-wrapper"
                
                data-overlay="black"
                data-opacity="3"
            >
                <div className="container">
                    <div className="breadcumb-content text-center">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>





            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/109.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">
                                <p className="sectionLead">{cardData.top}</p>

                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>
                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>



                            <div className="shambhu-services">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="sh-service-card">

                                        <div className="sh-service-left">
                                            <div className="sh-service-icon">
                                                🚌
                                            </div>
                                        </div>

                                        <div className="sh-service-content">
                                            <h4 className="sh-service-title">{service.name}</h4>
                                            <p className="sh-service-desc">{service.description}</p>
                                        </div>

                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title">
                                    Why Choose <span>Urbania On rent in Pune </span>
                                </h2>

                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Urbania on rent in Pune </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919209423113" className="pc-call">+91 9209423113</a>
                                            <a href="tel:+917620411277 " className="pc-call">+91 7620411277 </a>
                                            <a href="tel:+919284718314" className="pc-call">+91 9284718314</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919209423113"
                                                target="_blank" rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp me-1"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919209423113" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@urbaniaonrentpune.in" className="pc-email">
                                            booking@urbaniaonrentpune.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-house-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Urbania on rent in pune</strong><br />
                                            Saket Tata Power CHS, Swami Samarth Marg,
                                            Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                                            Maharashtra India - 400703
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Bushireforweddinginpune;